import { Component, EventEmitter, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmationService } from 'primeng/api';
import { ConsignmentService } from 'src/app/Services/consignment.service';
import { NotificationsService } from 'src/app/Services/shared/notifications.service';
import { NotificationTypes } from 'src/app/app.enums';
import { InviteCommentRequest } from 'src/app/components/artist-components/connected-galleries/connected-galleries.component';
import { ProductSoldRequest } from 'src/app/models/request/productsoldrequest.model';

@Component({
    selector: 'app-productsold',
    templateUrl: './productsold.component.html',
    styleUrls: ['./productsold.component.css'],
    inputs: ['productSoldData', 'isProductSoldDialogVisible'],
    outputs: ['onCloseDailog', 'productSold'],
    standalone: false
})
export class ProductSoldComponent implements OnInit {
  public isProductSoldDialogVisible!: boolean;
  public displayEmojiDialog: boolean = false;
  public productSoldData: ProductSoldRequest = {} as ProductSoldRequest;
  public formData: InviteCommentRequest = {} as InviteCommentRequest;
  public onCloseDailog = new EventEmitter<boolean>();
  public productSold = new EventEmitter<ProductSoldRequest>();

  constructor(private confirmationService: ConfirmationService, 
    private ngxSpinnerService: NgxSpinnerService, 
    private notificationsService: NotificationsService, 
    private consignmentService: ConsignmentService,
    private transloco: TranslocoService) { }

  ngOnInit(): void {
    console.log("Product Data", this.productSoldData);
  }

  public closeDialog() {
    this.isProductSoldDialogVisible = false;
    this.onCloseDailog.emit(this.isProductSoldDialogVisible)
  }

  public markProductAsSold($event: any) {
     // If SoldPrice is not set, use ArtistRevenue as SoldPrice
  if (!this.productSoldData.SoldPrice || this.productSoldData.SoldPrice <= 0) {
    this.productSoldData.SoldPrice = this.productSoldData.ArtistRevenue || 0;
  }
    this.confirmationService.confirm({
      message: this.transloco.translate('productsold.confirmMarkSold', { name: this.productSoldData.ArtistProductName }),
      accept: () => {
        this.ngxSpinnerService.show();
        this.consignmentService.markProductSold(this.productSoldData.ConsignmentId!, this.productSoldData.ArtistProductId!, this.productSoldData.SoldPrice!, this.formData.ProductSoldComment).subscribe((response) => {
          this.ngxSpinnerService.hide();
          if (response.Success) {
            this.notificationsService.showNotification(this.transloco.translate('productsold.success'), this.transloco.translate('productsold.markSoldSuccess'), NotificationTypes.Success);
            this.productSold.emit(this.productSoldData)
          } else { console.error(response); this.notificationsService.showNotification(this.transloco.translate('productsold.error'), this.transloco.translate('productsold.markSoldError'), NotificationTypes.Error); }
          this.isProductSoldDialogVisible = false;
        }, (error) => { console.error(error); this.ngxSpinnerService.hide(); this.isProductSoldDialogVisible = false; });
      }
    });
  }
  public openEmojiDialog() {
    this.displayEmojiDialog = !this.displayEmojiDialog;
  }

  public addEmoji(emoji: string) {
    console.log('Selected emoji:', emoji);
    this.formData.ProductSoldComment = (this.formData.ProductSoldComment || '') + emoji;
    this.displayEmojiDialog = false;
  }

  public closeEmojiDialog($event: any) {
    this.displayEmojiDialog = false;
  }

  public preventNegativeValues(event: any): void {
    let value = event.target.value;
      value = value.replace(/-/g, '');
      // Allow only valid decimal numbers (positive values with an optional decimal point)
      const regex = /^[0-9]*\.?[0-9]*$/;
  
      if (!regex.test(value)) {
          // If invalid, revert to previous valid value or set to empty string
          this.productSoldData.SoldPrice = 0;
      } else {
          // Ensure value remains a valid positive decimal number
          this.productSoldData.SoldPrice = value;
      }
    if (event.target.value < 0) {
      // event.target.value = 0;
      this.productSoldData.SoldPrice = 0
    }
  }
}
